import React, { useEffect, useState } from 'react';
// import '../style.scss';
import Header from 'components/Header';
import { Badge } from 'react-bootstrap';
import { ProSidebar, SidebarHeader, SidebarContent, Menu, MenuItem } from 'react-pro-sidebar';
import 'react-pro-sidebar/dist/css/styles.css';
import *  as logoLight from "../../images/logo-light.png"
import *  as logoSm from "../../images/logo-sm.png"
import { Link } from 'react-router-dom';
import { 
  BusinessOutlined, 
  ListAltOutlined, 
  RecordVoiceOverOutlined, 
  DescriptionOutlined, 
  ContactsOutlined, 
  GroupAddOutlined, 
  AssignmentIndOutlined, 
  HelpOutline, 
  AttachMoney,
  NotificationsOutlined,
  WidgetsOutlined,
  Settings,
  Code,
  ConfirmationNumberOutlined,
  SupervisorAccount
} from '@material-ui/icons';
import './style.css';
import Can from 'components/Can';

import * as facebook from '../../images/social/facebook.png';
import * as instagram from '../../images/social/instagram.png';
import * as linkedin from '../../images/social/linkedin.png';
import * as spotify from '../../images/social/spotify.png';
import * as youtube from '../../images/social/youtube.png';
import AlertNotification from 'components/AlertNotification';
import LoginService from 'services/login';

import { useCompany, useProfile, useUser } from 'models';
import { ToastContainer } from 'react-toastify';
import { MasterAgentProfiles } from 'helpers/Enum';
import { ModalProvider } from 'components/ModalGlobal';

export default function({children,...props}){
  const user = useUser()
  const profile = useProfile()
  const { company } = useCompany()

  const [countNotification, setCountNotification] = useState(0);
  const minWidth = 940;
  const isMobile = window.innerWidth <= minWidth;

  useEffect(()=>{
    if(!MasterAgentProfiles.includes(profile.id) && (!company || !company.isMasterAgent())){
      let body = document.body;
      let script = document.createElement('script');
      script.type = "text/javascript"
      script.id="hs-script-loader"
      script.async=true
      script.defer=true
      script.src="//js.hs-scripts.com/4478780.js"
  
      body.appendChild(script)
  
      return ()=>{
        body.removeChild(script);
      }
    }
  },[company]);

  const isElite = () => {
    return localStorage.getItem("elite") == 1 ? true : false;
  }

  const isMasterAgent = () => {
    return localStorage.getItem("masterAgent") == 1 ? true : false;
  }
  
  const resposive = (e) => {
    if(e.target.innerWidth <= minWidth){
      props.setCollapsed(true);
    }
  }

  return (
    <>
      <ModalProvider>
        {isMobile?<AlertNotification setCountNotification={setCountNotification}
        style={{
          position: 'fixed',
          zIndex: '202',
          top: '90px',
          left: props.collapsed?'-50px':'134px',
          transition: props.collapsed?'0s':'.5s',
          // display:props.collapsed?'none':'block'
        }}/>:''}
        <ProSidebar collapsed={props.collapsed} id="menu-lateral">
          <SidebarHeader>
            <div className="logo-box">
              <a href="/" className="logo text-center">
                <span className="logo-lg">
                  <img src={props.collapsed ? logoSm : logoLight} alt="" height="30" />
                </span>
              </a>
            </div>
          </SidebarHeader>
          <SidebarContent className="mt-5">
            <Menu iconShape="square">
              <Can do="resale.select" on="App">
                {/* {companies.filter(c => c.company_type_id == 2).length > 1 ? ( */}
                  <MenuItem icon={<BusinessOutlined className="icon-menu" />} active={true}>
                    <Link to="/companies" onClick={()=>isMobile ? props.setCollapsed(true) : props.setCollapsed(props.collapsed)}>
                      Empresas
                    </Link>
                  </MenuItem>
                {/* ): (<></>)} */}
              </Can>
              {company ? (
                <Can do="resale.info" on="App">
                  <MenuItem icon={<ListAltOutlined className="icon-menu" />}><Link to="/company" onClick={()=>isMobile ? props.setCollapsed(true) : props.setCollapsed(props.collapsed)}>Dados</Link></MenuItem>
                </Can>
              ) : (<></>)}
              <Can do="resale.attendance" on="App">
                <MenuItem icon={<RecordVoiceOverOutlined className="icon-menu" />}><Link to="/attendance" onClick={()=>isMobile ? props.setCollapsed(true) : props.setCollapsed(props.collapsed)}>Atendimento</Link></MenuItem>
              </Can>
              <Can do="document.index" on="App">
                <MenuItem icon={<DescriptionOutlined className="icon-menu" />}><Link to="/documents" onClick={()=>isMobile ? props.setCollapsed(true) : props.setCollapsed(props.collapsed)}>Documentos</Link></MenuItem>
              </Can>

              {/* {!company ? ( */}
                <Can do="send-notification" on="App">
                  <MenuItem icon={<NotificationsOutlined className="icon-menu" />}>
                    <Link to="/notifications" onClick={()=>isMobile ? props.setCollapsed(true) : props.setCollapsed(props.collapsed)}>Enviar Notificação</Link>
                  </MenuItem>
                </Can>
              {/* ) : (<></>)} */}

              {profile.havePermission('faq.index') && isElite() ? (
                <MenuItem icon={<HelpOutline className="icon-menu" />}>
                  <Link to="/faq-elite" onClick={()=>isMobile ? props.setCollapsed(true) : props.setCollapsed(props.collapsed)}>
                    FAQ - Elite
                  </Link>
                </MenuItem>
              ) : (<></>)}

              {profile.havePermission('faq-master-agent.index') && isMasterAgent() ? (
                <MenuItem icon={<HelpOutline className="icon-menu" />}>
                  <Link to="/faq-master-agent" onClick={()=>isMobile ? props.setCollapsed(true) : props.setCollapsed(props.collapsed)}>
                    FAQ - Master Agent
                  </Link>
                </MenuItem>
              ) : (<></>)}

              <Can do="bd.index" on="App">
                <MenuItem icon={<ContactsOutlined className="icon-menu" />}><a target="_blank" href="https://bdsumo.simt2b.com.br/sumo/login/" onClick={async(e)=>{
                  e.preventDefault();
                  let link = e.target.href;
                  let response = await LoginService.generateAutoLoginToken();
                  let token = response.data;
                  let newlink = document.createElement('a');
                  newlink.setAttribute('target', '_blank');
                  newlink.setAttribute('href', link+"?t-al="+token);
                  newlink.click();

                  isMobile ? props.setCollapsed(true) : props.setCollapsed(props.collapsed)
                }}>SUMO</a></MenuItem> 
              </Can>
              <Can do="user.index" on="App">
                <MenuItem icon={<GroupAddOutlined className="icon-menu" />}><Link to="/users" onClick={()=>isMobile ? props.setCollapsed(true) : props.setCollapsed(props.collapsed)}>Usuários</Link></MenuItem>
              </Can>
              <Can do="profile.index" on="App">
                <MenuItem icon={<AssignmentIndOutlined className="icon-menu" />}><Link to="/profiles" onClick={()=>isMobile ? props.setCollapsed(true) : props.setCollapsed(props.collapsed)}>Perfis</Link></MenuItem>
              </Can>
              <Can do="billing.resellers" on="App">
                <MenuItem icon={<AssignmentIndOutlined className="icon-menu" />}><Link to="/resale/revenue" onClick={()=>isMobile ? props.setCollapsed(true) : props.setCollapsed(props.collapsed)}>Enviar Email - Faturamento - Revendas</Link></MenuItem>
              </Can>
              <Can do="financial.total-geral-funds-by-type" on="App">
                <MenuItem icon={<AttachMoney className="icon-menu" />}>
                  <Link to="/financial" onClick={()=>isMobile ? props.setCollapsed(true) : props.setCollapsed(props.collapsed)}>Financeiro</Link>
                </MenuItem>
              </Can>
              <Can do="logs.index" on="App">
                <MenuItem icon={<Code className="icon-menu" />}>
                  <Link to="/logs" onClick={()=>isMobile ? props.setCollapsed(true) : props.setCollapsed(props.collapsed)}>Logs</Link>
                </MenuItem>
              </Can>

              <Can do="dashboard.cnaes" on="App">
                <MenuItem icon={<WidgetsOutlined className="icon-menu" />}>
                  <Link to="/dashboard-cnaes" onClick={()=>isMobile ? props.setCollapsed(true) : props.setCollapsed(props.collapsed)}>Dashboard CNAES</Link>
                </MenuItem>
              </Can>

              {/* <Can do="system.config" on="App">
                <MenuItem icon={<Settings className="icon-menu" />}>
                  <Link to="/config" onClick={()=>isMobile ? props.setCollapsed(true) : props.setCollapsed(props.collapsed)}>Config</Link>
                </MenuItem>
              </Can> */}

              <Can do="ticket.index" on="App">
                <MenuItem icon={<ConfirmationNumberOutlined className="icon-menu" />}>
                  <Link to="/tickets" onClick={()=>isMobile ? props.setCollapsed(true) : props.setCollapsed(props.collapsed)}>Tickets</Link> <Badge variant="danger">Beta</Badge>
                </MenuItem>
              </Can>

              <Can do="adm-page" on="App">
                <MenuItem icon={<SupervisorAccount className="icon-menu" />}>
                  <Link to="/admin" onClick={()=>isMobile ? props.setCollapsed(true) : props.setCollapsed(props.collapsed)}>Administração</Link>
                </MenuItem>
              </Can>

            </Menu>
            {isMobile?(
              <div className="col-social pl-0 text-center wrapper">
                <a target="_blank" href="https://www.facebook.com/ScanSourceBR/">
                  <img src={facebook} className="menu-social" alt="" height="23" />
                </a>
                <a target="_blank" href="https://www.instagram.com/scansourcebr/">
                  <img src={instagram} className="menu-social" alt="" height="23" />
                </a>
                <a
                  target="_blank"
                  href="https://www.linkedin.com/company/scansource-brasil"
                >
                  <img src={linkedin} className="menu-social" alt="" height="23" />
                </a>
                <a
                  target="_blank"
                  href="https://open.spotify.com/show/2GHIaHdjjiBDnycUW1uJMu?si=BHERnGFwQ9azpR7xqusphg"
                >
                  <img src={spotify} className="menu-social" alt="" height="23" />
                </a>
                <a target="_blank" href="https://www.youtube.com/user/ScanSourceBR">
                  <img src={youtube} className="menu-social" alt="" height="23" />
                </a>
              </div>
            ):''}

          </SidebarContent>
        </ProSidebar>
        <div className={"content-page"+(props.collapsed?' content-page-collapsed':'')} id="content-primary">
          <ToastContainer />
          <Header collapsed={props.collapsed} setCollapsed={props.setCollapsed} countNotification={countNotification}/>
          {/* <Container className='mt-3'>
            <Alert variant='danger'>
              <ReportProblemOutlined/> Existe pendências financeiras no seu cadastro. Regularize esta situação para liberação de crédito do seu cadastro. <Alert.Link href="#">Precisa de ajuda?</Alert.Link>
            </Alert>
          </Container> */}
          {children}
          <div className="fundo-menu-mobile" 
          style={{display:!props.collapsed && window.innerWidth <= minWidth?'block':'none'}}
          onClick={()=>props.setCollapsed(true)}></div>
        </div>
      </ModalProvider>
    </>
  );
};